import { api } from '../api.js';
import { resolveTenantId } from '../utils/tenantParams.js';

export const iotAccessApi = {
    reportTelemetry: (payload = {}) => api.post('/iot/v1/telemetry/report', { tenantId: resolveTenantId(), ...payload }),
    reportEvent: (payload = {}) => api.post('/iot/v1/event/report', { tenantId: resolveTenantId(), ...payload }),
    sendCommand: (payload = {}) => api.post('/iot/v1/command/send', { tenantId: resolveTenantId(), ...payload }),
    ackCommand: (payload = {}) => api.post('/iot/v1/command/ack', { tenantId: resolveTenantId(), ...payload }),
    getLatest: (deviceId, tenant = resolveTenantId()) =>
        api.get(`/iot/v1/device/${encodeURIComponent(deviceId)}/latest`, { params: { tenantId: tenant } }),
    /** 与环境监测页设备档案一致：含 deviceType（如 WEATHER_STATION、PEST_LAMP） */
    listDevices: (tenant = resolveTenantId()) =>
        api.get('/iot/v1/device/list', { params: { tenantId: tenant } })
};

